const v = "customers_view";

export const cubeCustomersViewUuid = `${v}.uuid`;

export const cubeCustomersViewName = `${v}.name`;

export const cubeCustomersViewFirstName = `${v}.first_name`;

export const cubeCustomersViewLastName = `${v}.last_name`;

export const cubeCustomersViewPhoneNumber = `${v}.phone_number`;

export const cubeCustomersViewEmail = `${v}.email`;

export const cubeCustomersViewRegion = `${v}.region`;

export const cubeCustomersViewPostalCode = `${v}.postal_code`;

export const cubeCustomersViewIsPro = `${v}.is_pro`;

export const cubeCustomersViewStatus = `${v}.status`;

export const cubeCustomersViewLoyaltyJoinedAt = `${v}.loyalty_joined_at`;
